const times = (loopCount, block) => {
    let accum = '';
    for (let i = 0; i < loopCount; i++) {
        accum += block.fn(i);
    }
    return accum;
};

export default times;
